import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class UserService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-accounts'] = environment.host('v2-accounts');
        this.host['v1-accounts'] = environment.host('v1-accounts');
        this.host['v1-personal'] = environment.host('v1-personal');
    }

    searchByEmailV2(email: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-accounts']}/v2/accounts/search/${email}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByEmailV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByEmailV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    searchByAccountIdV2(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-accounts']}/v2/accounts/${accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByAccountIdV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByAccountIdV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    searchByQueryV2(query: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-accounts']}/v2/accounts/search`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            params: { q: query }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByQueryV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByQueryV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteAccountV2(accountId: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-accounts']}/v2/accounts/${accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.deleteAccountV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.deleteAccountV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2LastTokenTimes(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-accounts']}/v2/accounts/${accountId}/last-times`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getV2LastTokenTimes.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getV2LastTokenTimes.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2EmailConfirmed(email: string): Observable<any> {
        email = email.replace('#', '%23');
        return this.client.request('GET', `${this.host['v2-accounts']}/v2/accounts/${email}/confirmed`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getV2EmailConfirmed.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getV2EmailConfirmed.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    setV2EmailConfirmed(email: string): Observable<any> {
        email = email.replace('#', '%23');
        return this.client.request('PUT', `${this.host['v2-accounts']}/v2/accounts/${email}/confirmed`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: { confirmed: true }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.setV2EmailConfirmed.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.setV2EmailConfirmed.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2AccountEmail(accountId: string, email: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-accounts']}/v2/accounts/${accountId}/email`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: { email: email }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.updateV2AccountEmail.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.updateV2AccountEmail.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2AccountAuthorities(accountId: string, role: string, authorities: string[]): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-accounts']}/v2/accounts/${accountId}/authorities`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: { role: role, authorities: authorities }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.updateV2AccountAuthorities.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.updateV2AccountAuthorities.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2Profile(accountId: string, profile: { firstname: string, lastname: string, nickname: string, country: string, gender: string, height: number, heightUnit: string, weight: number, weightUnit: string, dateOfBirth: string }): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-accounts']}/v2/accounts/${accountId}/profile`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                firstname: profile.firstname,
                lastname: profile.lastname,
                nickname: profile.nickname,
                country: profile.country,
                gender: profile.gender,
                height: profile.height,
                heightUnit: profile.heightUnit,
                weight: profile.weight,
                weightUnit: profile.weightUnit,
                dateOfBirth: profile.dateOfBirth
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.updateV2Profile.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.updateV2Profile.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    searchByEmailOnLegacyServer(product: string, email: string): Observable<any> {
        let legacyHosts: any[] = environment.legacyHosts;
        let legacyHost: any = legacyHosts.find(legacyHost => legacyHost.product == product);
        if (legacyHost == undefined || legacyHost.host == undefined) {
            return EMPTY;
        }
        return this.client.request('GET', `${legacyHost.host}/user/${email}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByEmailOnLegacyServer.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByEmailOnLegacyServer.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteByEmailOnLegacyServer(product: string, email: string): Observable<any> {
        let legacyHosts: any[] = environment.legacyHosts;
        let legacyHost: any = legacyHosts.find(legacyHost => legacyHost.product == product);
        if (legacyHost == undefined || legacyHost.host == undefined) {
            return EMPTY;
        }
        return this.client.request('DELETE', `${legacyHost.host}/user/${email}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.deleteByEmailOnLegacyServer.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.deleteByEmailOnLegacyServer.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    searchByEmail(email: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/account/${email}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByEmail.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByEmail.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    searchByAccountId(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/account/uid/${accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.searchByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.searchByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getJwtByAccountId(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getJwtByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getJwtByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateAccountDetailByAccountId(accountDetail: { accountId: string, email?: string, firstName: string, lastName: string, locale: string, timeZone: string, role: string }): Observable<any> {
        let body: any = {
            first_name: accountDetail.firstName,
            last_name: accountDetail.lastName,
            locale: accountDetail.locale,
            tz: accountDetail.timeZone,
            role: accountDetail.role
        }
        if (accountDetail.email && accountDetail.email.trim().length > 0) {
            body.email = accountDetail.email;
        }
        return this.client.request('PUT', `${this.host['v1-accounts']}/v1/jwt/detail/uid/${accountDetail.accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: body
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.updateAccountDetailByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.updateAccountDetailByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updatePersonalInfoByAccountId(accountId: string, personalInfo: { nickname: string, gender: string, country: string, dateOfBirth: string, height: number, heightUnit: string, weight: number, weightUnit: string }): Observable<any> {
        return this.client.request('POST', `${this.host['v1-personal']}/v1/data/personal/${accountId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: {
                data: {
                    nickname: personalInfo.nickname,
                    gender: personalInfo.gender,
                    country: personalInfo.country,
                    dateOfBirth: personalInfo.dateOfBirth,
                    height: personalInfo.height,
                    heightUnit: personalInfo.heightUnit,
                    weight: personalInfo.weight,
                    weightUnit: personalInfo.weightUnit,
                    aboutMe: '',
                    state: '',
                    city: ''
                }
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.updatePersonalInfoByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.updatePersonalInfoByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    resendWelcomeEmail(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/validate/resend`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.resendWelcomeEmail.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.resendWelcomeEmail.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    resendResetPassword(email: string): Observable<any> {
        return this.client.request('POST', `${this.host['v1-accounts']}/v1/jwt/password/reset/${email}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.resendResetPassword.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.resendResetPassword.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getResendWelcomeEmailUrl(email: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/validate/email/${email}/url`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getResendWelcomeEmailUrl.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getResendWelcomeEmailUrl.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getResendResetPasswordUrl(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/validate/reset/password/${accountId}/url`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getResendResetPasswordUrl.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getResendResetPasswordUrl.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getMigrationCode(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-accounts']}/v1/jwt/account/migration/code`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.getMigrationCode.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.getMigrationCode.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    queueDataMigration(accountId: string, code: string): Observable<any> {
        return this.client.request('POST', `${this.host['v1-accounts']}/v1/jwt/account/migration`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response',
            body: {
                code: code
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('UserService.queueDataMigration.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('UserService.queueDataMigration.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
